import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';

export const SUPPORT_EMAIL = 'support@jobflo.me';
export const COMPANY_NAME = 'JobFlo';
export const GOVERNING_LAW = 'the State of Texas, United States';

interface Section {
  title: string;
  body: React.ReactNode;
}

interface Props {
  title: string;
  effective: string;
  intro: React.ReactNode;
  sections: Section[];
}

export const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="body1" sx={{ mb: 1.5 }}>
    {children}
  </Typography>
);

export const List: React.FC<{ items: React.ReactNode[] }> = ({ items }) => (
  <Box component="ul" sx={{ mt: 0, mb: 1.5, pl: 3 }}>
    {items.map((item, index) => (
      <Typography key={index} component="li" variant="body1" sx={{ mb: 0.5 }}>
        {item}
      </Typography>
    ))}
  </Box>
);

/** The shared shape of the Terms and the Privacy Policy: a title, an effective date, numbered sections. */
const LegalPage: React.FC<Props> = ({ title, effective, intro, sections }) => (
  <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
    <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 0.5 }}>
      {title}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
      Effective {effective}.{' '}
      <Link component={RouterLink} to="/terms">
        Terms of Service
      </Link>
      {' · '}
      <Link component={RouterLink} to="/privacy">
        Privacy Policy
      </Link>
    </Typography>
    <Box sx={{ mb: 3 }}>{intro}</Box>
    {sections.map((section, index) => (
      <Box key={section.title} component="section" sx={{ mb: 3 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
          {index + 1}. {section.title}
        </Typography>
        {section.body}
      </Box>
    ))}
  </Container>
);

export default LegalPage;
